(function() {
    'use strict';

    angular.module( APP_ID )
        .component( 'exampleCourses', {
            bindings: {
                items:    '<'
            },
            templateUrl: 'app/views/partials/content/grid-example-courses.html',
            controller: ExpandableGridController,
            controllerAs: 'vm',

            renderingOptions: {
                'course-examples': {
                    inputs:    [ 'items="::customData.exampleCourses"' ]
                }
            }
        }).component( 'relatedStudyAreas', {
            bindings: {
                items:   '<'
            },
            templateUrl:    'app/views/partials/widgets/grid-related-areas.html',
            controller:     ExpandableGridController,
            controllerAs:   'vm'
        });



    /**
     *
     * Contains logic for behaviour and control of expandable preview/detail
     * within multiple-cell dynamic grids.
     *
     * @param {ng.IScope} $scope
     * @param {Utils} Utils
     * @param {Object} TEXTS
     */
    function ExpandableGridController(
        $scope,
        Utils,
        TEXTS
    ){

        /** @type {angular.IController} */
        var vm = this;





        /* ===== PRIVATE MEMBERS ============================================ */


        /** @constant */
        var SELECTION_NONE  = -1,
        CSS_MARGIN_NONE     = 'initial';


        /** @type {number} */
        var columnsCount;





        /* ===== EXPOSE TO THE SCOPE ======================================== */


        $scope._       = {};

        $scope._.COURSES = TEXTS.AREA.COURSE_EXAMPLES;
        $scope._.AREAS   = TEXTS.AREA.RELATED_AREAS;

        $scope.Utils   = Utils;





        /* ===== EXPOSE TO THE CONTROLLER =================================== */


        // Members
        vm.selectedItemIndex    = SELECTION_NONE;
        vm.expandCollapse       = 0;


        // Methods
        vm.Utils                = Utils;
        vm.selectItem           = selectItem;
        vm.shouldApplyMargin    = shouldApplyMargin;





        /* ===== RUN ON INSTANTIATION ======================================= */


        /** @constructor */
        //vm.$onInit = function() {}





        /* ===== PUBLIC METHODS ============================================= */


        /**
         * Shows a detail for an item on given `itemIndex`. If this item is
         * already selected and its detail opened, close (deselect) it.
         *
         * @param {number} itemIndex
         * @param {any} $event
         */
        function selectItem( itemIndex, $event ){
            var itemElement = angular.element( $event.currentTarget ).parent();

            columnsCount = getColumnsCount( itemElement );

            if ( itemIndex == vm.selectedItemIndex ) {
                // Clicking on already selected item => Deselect
                vm.selectedItemIndex  = SELECTION_NONE;
                vm.expandCollapse     = CSS_MARGIN_NONE;
            } else {
                var previewElement = itemElement.next(),
                previewHeightInPx  = previewElement.outerHeight( true ); // Incl. margins

                vm.selectedItemIndex  = itemIndex;
                //Look for element height and add margin
                vm.expandCollapse     = previewHeightInPx;
            }
        }


        /**
         * Evaluates whether or not should the item on given `itemIndex` apply
         * margin offset to compensate for the opened detail panel.
         *
         * The incentive is to return `true` for all the items in a row with
         * currently selected item.
         *
         * @param {number} itemIndex
         * @returns {boolean}
         */
        function shouldApplyMargin( itemIndex ) {
            if ( vm.selectedItemIndex == -1 ) return false;

            return Math.ceil( ( itemIndex + 1 ) / columnsCount ) == Math.ceil( ( vm.selectedItemIndex + 1 ) / columnsCount );
        }





        /* ===== PRIVATE FUNCTIONS ========================================== */


        /**
         * Returns number of items in a single row.
         *
         * @param {DOMElement} itemElement
         * @returns {number}
         */
        function getColumnsCount( itemElement ) {
            var listElement = itemElement.parent().parent().parent();

            return Math.floor( listElement.width() / itemElement.width() );
        }
    }



    ExpandableGridController.$inject = [ '$scope', 'Utils', 'TEXTS' ];
})();
